(function () {
    'use strict';

    angular.module("imApp").factory("orderCustComService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 2350,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 2351,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
